import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { uploadDocsApi } from "./uploadDocsAPI";

const initialState = []

export const uploadAttachment = createAsyncThunk(
    'ui/uploadAttachment',
    async (obj, thunkAPI) => {
      const { getState } = thunkAPI;
      const response = await uploadDocsApi(obj);
      return response.data;
    }
);

const uploadDocsSlice = createSlice({
    name: 'uploadAttachment',
    initialState,
    reducers: {
      setInverterData: (state, action) => {
        //state.inverter = action.payload?.inverter;
      }
    },
    extraReducers: (builder) => {
        builder
          .addCase(uploadAttachment.pending, (state) => {
            return {
              ...state,
              status: "loading",
              updateLoaded: false,
              updateApiFailed: false,
              uploadResponse: initialState
            }
          })
          .addCase(uploadAttachment.fulfilled, (state, action) => {
            return {
              ...state,
              status: "idle",
              uploadResponse: action.payload,
              updateApiFailed: false,
              updateLoaded: true
            }
          })
          .addCase(uploadAttachment.rejected, (state) => {
            return {
              ...state,
              updateLoaded: true,
              status: "idle",
              updateApiFailed: true,
            }
          })
        },
});

export const getDocumentUploadResponse = (state) => state.uploadDocument?.uploadResponse;

export default uploadDocsSlice.reducer;
